import {useViewportSize} from '#hook';

import OrderDetail from './OrderDetail';
import OrderDetailFixed from './OrderDetailFixed';

import {OrderDetailProps} from './OrderDetail.types';

const OrderDetailWithFixed = ({order, isNotUpcomingOrder = false}: OrderDetailProps) => {
  const {isMobile} = useViewportSize();
  return !isMobile ? (
    <OrderDetail order={order} isNotUpcomingOrder={isNotUpcomingOrder} />
  ) : (
    <OrderDetailFixed order={order} isNotUpcomingOrder={isNotUpcomingOrder} />
  );
};

export default OrderDetailWithFixed;
